import React from "react";
import { ReactComponent as SoundFull } from "../../../../../assets/icons/videoPlayer/soundFull.svg";
import { ReactComponent as SoundLow } from "../../../../../assets/icons/videoPlayer/soundLow.svg";
import { ReactComponent as SoundMuted } from "../../../../../assets/icons/videoPlayer/soundMuted.svg";

// soundLevel = 1 : full || 0 : low || -1 : muted

function Sound({ color = "var(--gold)", width = "20px", volume = 0, className = "", onClick = () => {} }) {
  return volume === 1 ? (
    <SoundFull fill={color} width={width} height={width} className={className} onClick={onClick} />
  ) : volume === 0 ? (
    <SoundLow fill={color} width={width} height={width} className={className} onClick={onClick} />
  ) : (
    <SoundMuted fill={color} width={width} height={width} className={className} onClick={onClick} />
  );
}

export default Sound;
